import { openSwitchUserTab } from './urlValidation'

// Set in App.js: global.adminSwitchUserConfig = true (token) / false (old flow).
export const isSecureSwitchUserEnabled = () =>
    global.adminSwitchUserConfig === true

// New flow: API-issued token, opens `/switch#<token>`.
export const secureSwitchUser = (userId) => openSwitchUserTab(userId, true)

// Old flow: opens `/switch?user_id=<base64 id>` (no tokens).
export const legacySwitchUser = (userId) => openSwitchUserTab(userId, false)

export const switchUserControl = (userId) =>
    isSecureSwitchUserEnabled()
        ? secureSwitchUser(userId)
        : legacySwitchUser(userId)
